import React, { useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';

import PersonAvatar from 'app/components/CommonStyled/PersonAvatar';
import PersonIcon from 'app/components/shared/icons/person-icon';

import { IDrawer } from '../../../PublicationContent';
import {
  DataTypePersonAvatarContainer,
  DataTypePersonIconContainer,
  DataTypePersonPillText,
  DataTypePersonPillWrapper,
} from './styled';

export const dataTypePersonContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="people"], [data-type="person"]').forEach((person) => {
    const slug = person.getAttribute('data-slug');
    const name = person.textContent;
    const profileImage = person.getAttribute('data-profile-image');
    const template = document.createElement('div');

    template.innerHTML = ReactDOMServer.renderToString(
      <DataTypePersonPill name={name || ''} profileImage={profileImage} />
    );

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'people' });
    });

    person.replaceWith(template.firstChild);
  });
};

interface DataTypePersonPillProps {
  name: string;
  profileImage?: string;
}

export const DataTypePersonPill = ({ name, profileImage }: DataTypePersonPillProps) => {
  const hasProfileImage = useMemo(() => {
    return profileImage && profileImage.length > 0;
  }, [profileImage]);
  return (
    <DataTypePersonPillWrapper>
      {hasProfileImage ? (
        <DataTypePersonAvatarContainer>
          <PersonAvatar highlighted size={24} avatar={profileImage} name={name} />
        </DataTypePersonAvatarContainer>
      ) : (
        <DataTypePersonIconContainer>
          <PersonIcon width={16} height={16} fill={'var(--color-data-people-foreground)'} />
        </DataTypePersonIconContainer>
      )}
      <DataTypePersonPillText hasProfileImage={hasProfileImage}>{name}</DataTypePersonPillText>
    </DataTypePersonPillWrapper>
  );
};
